<template>
  <div>
  <box class="main-top-margin">
    
      <div v-if="isLoading" class="text-center ma-12">
        <v-progress-circular
          size="48"
          width="4"
          indeterminate
          color="grey lighten-2"
        ></v-progress-circular>
      </div>

      <template v-else>
        <v-row dense>
          <v-col cols="12" class="px-2 py-6">
          <v-form
            ref="userForm"
            v-model="validForm"
            lazy-validation
          >
            <v-text-field
              autocomplete="kName"
              name="kName"
              v-model="user.name"
              :label="$t('USER-LABEL-NAME')"
              :rules="[rules.required, rules.name]"
            >
            </v-text-field>

            <v-text-field
              autocomplete="kEmail"
              name="kEmail"
              v-model="user.email"
              :label="$t('USER-LABEL-EMAIL')"
              :rules="[rules.required, rules.email]"
            >
            </v-text-field>

            <v-select
              v-model="user.language_id"
              :items="languages"
              item-text="label"
              item-value="id"
              :label="$t('USER-LABEL-LANGUAGE')"
              :rules="[rules.required]"
            >
            </v-select>

            <v-select
              v-model="user.unitSystem"
              :items="unitSystems"
              :label="$t('USER-LABEL-UNIT_SYSTEM')"
              :rules="[rules.required]"
            >
            </v-select>

            <template v-if="!isMyAccount">
              <v-select
                v-model="user.role"
                :items="userRoles"
                :label="$t('USER-LABEL-ROLE')"
                :rules="[rules.required]"
              >
              </v-select>

              <v-select
                v-if="currentUser.role == 'su'"
                v-model="user.mandate_id"
                :items="mandates"
                item-value="id"
                item-text="name"
                :label="$t('USER-LABEL-MANDATE')"
              >
              </v-select>
            </template>
            <template 
                v-if="['sm', 'su', 'adm'].includes(currentUser.role) && showWarehouses">
              <v-select
              :clearable="currentUser.role != 'sm'"
                v-model="user.warehouse_id"
                :readonly="currentUser.role == 'sm'"
                :items="warehouses"
                :label="$t('USER-LABEL-WAREHOUSE')"
              >
              </v-select>
            </template>
            <v-btn
            v-if="canChangePassword"
              elevation="0"
              color="secondary"
              @click="openChangePasswordDialog"
              > <small><lang t="GLOBAL-BTN-CHANGE_PASSWORD"></lang
            ></small></v-btn>

            <template v-if="!user.id || isMyAccount == true">

              <template v-if="!isMyAccount">
                <password-field
                  v-model="user.password"
                  label="USER-LABEL-PASSWORD-NEW"
                ></password-field>
                <v-text-field
                  v-model="user.rePassword"
                  type="password"
                  :label="$t('USER-LABEL-PASSWORD_NEW-REPEAT')"
                  required
                  :rules="[passwordConfirmationRule]"
                ></v-text-field>
              </template>
            </template>
           
          </v-form>

          <v-form
            v-if="isMyAccount"
            ref="passwordForm"
            v-model="validPasswordForm"
            lazy-validation
          >

            <v-text-field
              :rules="[rules.required]"
              v-model="user.currentPassword"
              type="password"
              :label="$t('USER-LABEL-PASSWORD-CURRENT')"
              required
            ></v-text-field>
            <password-field
              v-model="user.password"
              label="USER-LABEL-PASSWORD-NEW"
            ></password-field>
            <v-text-field
              :rules="[rules.required, passwordConfirmationRule]"
              v-model="user.rePassword"
              type="password"
              :label="$t('USER-LABEL-PASSWORD_NEW-REPEAT')"
              required
            ></v-text-field>

            <v-divider class="my-2" style="border: none;"></v-divider>

            <v-btn
              elevation="0"
              color="secondary"
              @click="savePassword()"
              :loading="isSavingPassword"
              > <small><lang t="GLOBAL-BTN-CHANGE_PASSWORD"></lang
            ></small></v-btn>
          </v-form>
        </v-col>
        </v-row>
      </template>
  
  </box>
  <box class="mt-2" background="transparent" borderColor="transparent" padding="1em 0" v-if="!isLoading">
    
    <div class="d-flex justify-end">
          <v-btn
              color="secondary"
              :loading="isSaving"
              bottom
              right
              @click="save()"
              style="z-index:100;"
            >
              <small><lang t="GLOBAL-BTN-SAVE" /></small>
            </v-btn>
    </div>

</box>
<UserChangePasswordDialog :visible="openChangePassDialog" :user="user" @close="openChangePassDialog = false"/>
</div>
 
</template>

<script>

import passwordField from "@/components/PasswordField";
import Box from "../../components/ui-elements/Box.vue";
import UserChangePasswordDialog from "../../components/user/UserChangePasswordDialog.vue";

export default {
  components: {
    passwordField,
    Box,
    UserChangePasswordDialog
  },

  data() {
    return {
      isLoading: false,
      isSaving: false,
      canChangePassword: false,
      isSavingPassword: false,
      openChangePassDialog: false,
      isUploading: false,
      showWarehouses: false,
      isMyAccount: false,

      showPassword: false,
      user: null,

      validForm: false,
      validPasswordForm: false,

      unitSystems: [
        {
          text: this.$t('CLIENT-UNITSYSTEM-METRIC'),
          value: "metric",
        },
        {
          text: this.$t('CLIENT-UNITSYSTEM-IMPERIAL'),
          value: "imperial",
        },
      ],

      userRoles: [
        {
          text: this.$t("USER-ROLE-ADM"),
          value: "adm",
        },
        {
          text: this.$t("USER-ROLE-SM"),
          value: "sm",
        },
        {
          text: this.$t("USER-ROLE-OP"),
          value: "op",
        },
        {
          text: this.$t("USER-ROLE-PRDSYSSUP"),
          value: "prdSysSup",
        },
      ],

      mandates: [],
    };
  },

  computed: {

    warehouses(){
      if(!this.user.mandate_id) return [];
      const selectedMandate = this.mandates.find(el => el.id == this.user.mandate_id);
      if(!selectedMandate) return [];
      return selectedMandate.warehouses.map(warehouse => {
        return {
          text: warehouse.name,
          value: warehouse.id
        }
      });
    },
    passwordConfirmationRule() {
      return (
        this.user.password === this.user.rePassword ||
        this.$t("GLOBAL-FORM-PASSWORDS_MUST_MATCH")
      );
    },

    languages() {
      return this.$store.getters.getTranslatedLanguages;
    },
    
    currentLanguageId() {
      return this.$store.getters.currentUser.language_id;
    }
  },

  watch: {
    async $route(newVal, oldVal) {
      if (newVal.name == "myAccount" && newVal.name != oldVal.name) {
        this.isMyAccount = true;
        await this.initialize(this.currentUser.id);
      }
    },
    currentLanguageId(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.$router.go();
    },
    'user.role'(){
      if(this.user.role == 'sm'){
        if(this.currentUser.role == 'sm' && this.user.warehouse_id == null){
          this.showWarehouses = false;
        }else{
          this.showWarehouses = true;
        }
      }else{
        this.showWarehouses = false;
      }
    }
  },

  async created() {

    if (this.$route.params.id) {
      await this.initialize(this.$route.params.id);
      this.initPasswordChangeButtonStatus();
    } else {
      if (this.$route.name == "myAccount") {
        this.isMyAccount = true;
        await this.initialize(this.currentUser.id);
      } else {
        if (this.currentUser.role == "su") {
          this.fetchMandates();
        }

        this.user = {
          name: null,
          email: null,
          unitSystem: null,
          language_id: null,
          role: null,
          password: null,
          rePassword: null,
        };
      }
    }
  },

  mounted() {},

  methods: {
    initPasswordChangeButtonStatus(){
      if(!this.$route.params.id) return;
      if(Number(this.$route.params.id) === Number(this.currentUser.id)){
        this.canChangePassword = true;
      }else{
        if (["su", 'adm'].includes(this.currentUser.role) && this.user && !["su"].includes(this.user.role)){
          this.canChangePassword = true;
        }else{
          this.canChangePassword = false;
        }
      }
      
    },

    openChangePasswordDialog(){
      this.openChangePassDialog = true;
    },

    save() {
      if (!this.$refs.userForm.validate()) {
        return false;
      }

      this.isSaving = true;

      // create a new account (user)
      if (!this.user.id) {
        this.user.mandate_id =
          this.user.mandate_id ?? this.currentUser.mandate_id;
        this._save("post", "users");

        // update existing user
      } else {
        this._save("put", "users/" + this.user.id);
      }
    },

    _save(requestMethod, url) {
      this.axios[requestMethod](url, this.user)
        .then(async (res) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
          });

          if (!this.user.id) {
            await this.initialize(res.data.id);
          } else {
            this.$store.dispatch("changeLanguage", { user: this.user });
          }
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-ERROR"),
            type: "warning",
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

    savePassword() {
      if (!this.$refs.passwordForm.validate()) {
        return false;
      }

      this.isSavingPassword = true;

      if (this.user.currentPassword != "" && this.user.password != "") {
        this.axios
          .post("user/changePassword", {
            password: this.user.currentPassword,
            new_password: this.user.password,
          })
          .then((res) => {
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-MESSAGE-PASSWORD_SUCCESSFULLY_CHANGED"),
            });
          })
          .catch((error) => {
            console.error(error.response);
            this.$store.dispatch("setSnackbar", {
              text: error.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.isSavingPassword = false;
          });
      }
    },

    async initialize(userId) {
      this.isLoading = true;

      await this.axios.get("users/" + userId).then((res) => {
        this.user = res.data;

        if (["su", "adm", "sm"].includes(this.currentUser.role)) {
          this.axios.get("mandates").then((res) => {
            this.mandates = res.data;
            this.isLoading = false;
          });
        } else {
          this.isLoading = false;
        }

        this.changeTitle();
      });
    },

    fetchMandates() {
      this.isLoading = true;

      this.axios.get("mandates").then((res) => {
        this.mandates = res.data;
        this.isLoading = false;
      });
    },

    changeTitle() {
      this.$route.meta.pageTitle = this.isMyAccount
        ? "MY_ACCOUNT-HEADER"
        : this.user.name;

      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
    },

    getImgSrc() {
      if (this.isUploading) {
        return false;
      }

      let imgUrl = false;

      if (this.user.logoTmp != null) {
        imgUrl = this.user.logoTmp;
      } else {
        imgUrl =
          this.user.logo != null ? this.$config.cdn + this.user.logo : false;
      }

      return imgUrl;
    },

    imageRemove() {
      this.user.logo = null;
      this.user.logoTmp = null;
      this.$forceUpdate();
    },

    imageUpload(file) {
      if (typeof file == "undefined") {
        return;
      }

      this.isUploading = true;

      let formData = new FormData();
      formData.append("file", file, file.name);

      // additional data
      formData.append("key", "file");

      this.axios
        .post("/upload", formData)
        .then((response) => {
          this.user.logo = response.data.filename;
          this.user.logoTmp = response.data.url;

          setTimeout(() => {
            this.isUploading = false;
          }, 1000);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss"></style>
